import { createThirdwebClient } from "thirdweb"
import { env } from "../config/env"

if (!env.thirdwebClientId) {
  throw new Error("VITE_THIRDWEB_CLIENT_ID is required. Please set it in your .env file.");
}

export const client = createThirdwebClient({ clientId: env.thirdwebClientId })
